module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-why-what",
    attrs: {
      "id": "what-apart"
    }
  }, [_c('div', {
    staticClass: "custom-why-what__container"
  }, [_c('div', {
    staticClass: "custom-why-what__upper"
  }, [_c('div', {
    staticClass: "custom-why-what__left"
  }, [_c('img', {
    staticClass: "custom-why-what__img",
    attrs: {
      "src": _vm.props.image,
      "alt": "Dr. Raquel high fives a boy."
    }
  })]), _c('div', {
    staticClass: "custom-why-what__right",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })]), _vm._l((_vm.props.what_sets), function(content, j) {
    return (j <= 1) ? _c('div', {
      key: j,
      staticClass: "custom-why-what__row"
    }, [_c('div', {
      staticClass: "custom-why-what__title",
      domProps: {
        "innerHTML": _vm._s(content.title)
      }
    }), _c('div', {
      staticClass: "custom-why-what__content",
      domProps: {
        "innerHTML": _vm._s(content.content)
      }
    })]) : _vm._e()
  }), _c('div', {
    staticClass: "custom-why-what__jham-img-container"
  }, [_c('img', {
    staticClass: "custom-why-what__jham-img",
    attrs: {
      "src": _vm.props.jham_img,
      "alt": "Dr. Jham helps a patient"
    }
  })]), _vm._l((_vm.props.what_sets), function(content, i) {
    return (i > 1) ? _c('div', {
      key: i,
      staticClass: "custom-why-what__row"
    }, [_c('div', {
      staticClass: "custom-why-what__title",
      domProps: {
        "innerHTML": _vm._s(content.title)
      }
    }), _c('div', {
      staticClass: "custom-why-what__content",
      domProps: {
        "innerHTML": _vm._s(content.content)
      }
    })]) : _vm._e()
  })], 2), _c('Icon', {
    staticClass: "custom-why-what__footer-divider",
    attrs: {
      "name": "patient-top-blue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a93ce8c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-why-what/custom-why-what.pug
// module id = 703
// module chunks = 1